export default "__VITE_ASSET__DDG2VyzQ__"